import React from 'react'
import "./Preview.css"
import previewImage from '../../assets/images/png/PreviewImage.png'
import { EnvironmentRegistry } from '../../services/registry/environmentRegistry'
const Preview = () => {
  const env = EnvironmentRegistry.getEnvironment();
  const lob = EnvironmentRegistry.getCurrentLob();
  return (
    <>
      {/* <iframe src="http://marssfaphuat.localhost:3001/?appdesigner=true" title="App Preview"  className="preview"></iframe> */}
       <iframe src={`https://${lob}.salescode.ai/#/`} title="App Preview"  className="app_preview"></iframe>
      {/* {!(env && lob && env === 'uat') && <img className="app_preview" alt="preview" src={previewImage} style={{width:"100%"}}/>} */}
    </>

  )
}

export default Preview